import { render, staticRenderFns } from "./PrePostAdd.vue?vue&type=template&id=85d197a0"
import script from "./PrePostAdd.vue?vue&type=script&lang=js"
export * from "./PrePostAdd.vue?vue&type=script&lang=js"
import style0 from "./PrePostAdd.vue?vue&type=style&index=0&id=85d197a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports